
import Paragraph from '../typography/Paragraph.vue';

export default {
  name: 'AppSwitch',
  components: { Paragraph },

  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    keyName: {
      type: String,
      default: '',
    },
  },

  computed: {
    syncedValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
};
